<template>
<div :class="[showBorder?'ty-border full-width px-2 pb-3 mt-2':'']">
    <ty-row :gutter="20">
        <ty-col xs="24" sm="12" md="12" lg="12" xl="13">
            <ty-input :max-length="32" v-model="transaction.name" label="عنوان درآمد" class="full-width" required/>
        </ty-col>
        <!-- <ty-col xs="24" sm="12" md="6" lg="6" xl="5">
            <ty-input-number @input="$emit('change')" v-model="transaction.count" :min="1" label="تعداد" plus-color="white" minus-color="white" class="full-width" required/>
        </ty-col> -->
        <ty-col xs="24" sm="12" md="12" lg="12" xl="11">
            <ty-currency-input @change="$emit('change')" v-model="transaction.value" class="full-width" label="درآمد" required>
                <div class="fw-300 fs-14 ml-2 ty-color-primary" slot="suffix">تومان</div>
            </ty-currency-input>
        </ty-col>
    </ty-row>
</div>
</template>

<script>
    export default {
        inject: ['getInstance'],
        props: {
            transaction: {
                type: Object,
            }
        },
        data() {
            return {
                choices: {
                    default_price: null,
                    default_price_without_off: null,
                    price_choice: null, other_choices: []},
                choices_model: [],
                loading: false,
            }
        },
        computed: {
            showBorder() {
                return this.choices.price_choice||(this.choices.other_choices&&this.choices.other_choices.length>0)
            }
        }
    }
</script>